import {reducer as contentLibrary} from './components/content-library-page/reducer'
import {reducer as externalConfig} from './external-config/reducer'

export const rootReducer = {
  config: (s = {}) => s,
  contentLibrary,
  externalConfig,
}
